import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PremiumFeatureRevamp from "./component";
import { withRouter } from "react-router-dom";
import withLogin from "../with-login";
import withWishlist from "../with-wishlist";

const mapStateToProps = ({
    carDetails: {
        content,
        config
    }
}) => ({
    content,
    config
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withLogin(withWishlist(withRouter(connect(mapStateToProps, mapDispatchToProps)(PremiumFeatureRevamp))));
